// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"thumbnail-gz2Kj","small":"small-Epoei"};